import React from "react";
import "./custom-error.css";
import ErrorIcon from "../../assets/error-icon.svg";
import General from "../../stores/GeneralStore";

const CustomErrorToaster = ({
  errorMessage,
}) => {
  return (
    <div className="custom-error-wrapper">
      <img src={ErrorIcon} className="error-icon" />
      <span>{General?.codeLabels[errorMessage]?.label
        ? General?.codeLabels[errorMessage]?.label
        : errorMessage}</span>
    </div>
  );
};

export default CustomErrorToaster;
